import React from 'react';

export interface AgentIconProps {
  readonly colorScheme?: 'dark' | 'light';
  readonly width?: string | number;
  readonly height?: string | number;
  readonly className?: string;
}

interface AgentIconBadgeProps extends AgentIconProps {
  readonly children: React.ReactNode;
}

/** Shared circular Cowbell-blue badge chrome for system agent avatars. */
export function AgentIconBadge({
  width = '100%',
  height = '100%',
  className = '',
  children,
}: AgentIconBadgeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      {children}
    </svg>
  );
}
